module.exports = __webpack_public_path__ + "img/skull_10_bj.6b5e934b.png";